import { ExportAttachmentStatus } from "models/propTypes/revisorPropTypes";

interface ExportFailure {
  status?: number;
  message?: string;
}

export const getExportFailureReason = (error: unknown, noPermissionText: string): string | undefined => {
  const failure = error as ExportFailure | undefined;
  if (failure?.status === 403) {
    return noPermissionText;
  }

  return failure?.message?.trim().replace(/\.$/, "") || undefined;
};

export const describeFailedExports = (failedExports: ExportAttachmentStatus[]) =>
  failedExports
    .map((result) => result.typeText.toLocaleLowerCase() + (result.reason ? ` (${result.reason})` : ""))
    .join(", ");
